import { List, ListItem, ListProps, Stack, StackProps } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import LabeledValue, {
  LabeledValueContextProvider,
} from "components/Shared/LabeledValue";
import {
  RECEIVED_EMAIL_CATEGORY_BRAND_EMAIL_HELP_TEXT,
  RECEIVED_EMAIL_CATEGORY_LABELS,
  RECEIVED_EMAIL_CATEGORY_PLUS_SUFFIXES,
  getShownReceivedEmailCategories,
} from "utils/receivedEmailCategories";
import { CopyableBrandEmail } from "./BrandEmail";

const fragment = gql(/* GraphQL */ `
  fragment BrandEmailsFields on Brand {
    id
    slug
    brandModulesList(orderBy: MODULE_ASC) {
      id
      module
    }
  }
`);

type Props = ListProps &
  StackProps & {
    brand: FragmentType<typeof fragment> | null | undefined;
    isLoading?: boolean;
  };

export default function BrandEmails({
  brand: brandFragment,
  isLoading,
  ...rest
}: Props) {
  const brand = getFragmentData(fragment, brandFragment);

  const aliases = getShownReceivedEmailCategories(brand?.brandModulesList);

  return (
    <Stack as={List} spacing={5} {...rest}>
      <LabeledValueContextProvider
        isLoading={isLoading}
        statProps={{ as: ListItem, my: 0, py: 0 }}
      >
        <LabeledValue
          label="General"
          value={<CopyableBrandEmail slug={brand?.slug} isLinked isTruncated />}
          valueProps={{ fontWeight: 500 }}
          helpText={
            <>
              Used for sharing general brand content
              {aliases.length > 0 ? (
                <>
                  {" "}
                  <em>that does not have a dedicated email address below</em>
                </>
              ) : (
                ""
              )}
              .
            </>
          }
        />

        {aliases.map((alias) => (
          <LabeledValue
            key={alias}
            label={RECEIVED_EMAIL_CATEGORY_LABELS[alias]}
            helpText={RECEIVED_EMAIL_CATEGORY_BRAND_EMAIL_HELP_TEXT[alias]}
            valueProps={{ fontWeight: 500 }}
            value={
              <CopyableBrandEmail
                slug={brand?.slug}
                plusSuffix={RECEIVED_EMAIL_CATEGORY_PLUS_SUFFIXES[alias]}
                isLinked
                isTruncated
              />
            }
          />
        ))}
      </LabeledValueContextProvider>
    </Stack>
  );
}
